export const getHeaders = (): string[] => {
  return ['Fund',
    'ID',
    'Registration state',
    'Registration number',
    'Registration date',
    'Initial closing',
    'Final closing',
    'Investment period',
    "Fund's term",
    'Management company'];
};
